export default __webpack_public_path__ + "static/media/flowfriendlyhome.d4444bcf.jpeg";